import React from "react";
import Layout from "../../Layout/Layout";
const Public = () => {
  return (
    <>
      <Layout />
    </>
  );
};

export default Public;
